import React from 'react';
import { useTranslation } from 'Shared/Hooks/useTranslation';
import styled from 'styled-components';

import Text from 'crehana-ui/Text';
import { secondaryMain } from 'crehana-ui/styles/colors';
import ArrowBottom from 'crehana-icons/ArrowBottom';

import useCollapse from 'Jsx/Shared/Hooks/useCollapse';
import locales from '../../../v2/i18n/localeEs';

const translations = locales.es;

export const Rotate = styled.div<{ selected: boolean }>`
  transform-origin: center;
  transform: ${props => (props.selected ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 300ms ease;
`;

interface FAQItemProps {
  defaultOpen?: boolean;
  title: string;
  text: string;
}

const FAQItem: React.FC<FAQItemProps> = ({ defaultOpen, title, text }) => {
  const { getCollapseProps, getToggleProps, isOpen } = useCollapse({
    defaultOpen,
  });

  return (
    <li className="border border-solid border-gray-main p-24 mb-16">
      <button
        type="button"
        className="w-full text-left outline-none flex justify-between"
        {...getToggleProps()}
      >
        <p className="pr-24 font-subtitle3">{title}</p>
        <Rotate selected={isOpen}>
          <ArrowBottom size={16} color={secondaryMain} />
        </Rotate>
      </button>

      <div {...getCollapseProps()}>
        <div className="mt-8 sm:pr-24">
          <Text as="p" color="gray-dark">
            {text}
          </Text>
        </div>
      </div>
    </li>
  );
};

const FreeCourseFAQs = () => {
  const { t } = useTranslation();

  return (
    <div className="my-56">
      <h4 className="mb-24 font-h4">
        {t('FAQ_TITLE', {
          defaultValue: translations.FAQ_TITLE,
        })}
      </h4>

      <ul>
        <FAQItem
          defaultOpen
          title={t('FAQ_QUESTION1_TITLE', {
            defaultValue: translations.FAQ_QUESTION1_TEXT,
          })}
          text={t('FAQ_QUESTION1_TEXT', {
            defaultValue: translations.FAQ_QUESTION1_TEXT,
          })}
        />

        <FAQItem
          title={t('FAQ_QUESTION2_TITLE', {
            defaultValue: translations.FAQ_QUESTION2_TITLE,
          })}
          text={t('FAQ_QUESTION2_TEXT', {
            defaultValue: translations.FAQ_QUESTION2_TEXT,
          })}
        />

        <FAQItem
          title={t('FAQ_QUESTION3_TITLE', {
            defaultValue: translations.FAQ_QUESTION3_TITLE,
          })}
          text={t('FAQ_QUESTION3_TEXT', {
            defaultValue: translations.FAQ_QUESTION3_TEXT,
          })}
        />
      </ul>
    </div>
  );
};

export default FreeCourseFAQs;
